import * as THREE from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import {EXRLoader} from "three/examples/jsm/loaders/EXRLoader.js";

export const HDR_MAP_LOADER = {
  rgb: "rgb",
  pmremGenerator: "pmremGenerator",
  pmremGeneratorEXR: "pmremGeneratorEXR"
}

export function loadHDRMap(scene, renderer, hdrLoader = HDR_MAP_LOADER.pmremGeneratorEXR) {
  //const hdrUrl = 'https://quotecountertops.com/video/sqft/hdr/comfy_cafe_1k.hdr';
  //const hdrUrl = 'https://quotecountertops.com/video/sqft/hdr/gray complex.exr';
  //const hdrUrl = 'https://quotecountertops.com/video/sqft/hdr/gray copy high contrast lighter.exr';
  const hdrUrl = 'https://qc-cdn.s3.amazonaws.com/hdr/gray%20copy%20high%20contrast%20lighter.exr';

  if (hdrLoader === HDR_MAP_LOADER.rgb) {
    const rgbeLoader = new RGBELoader();

    rgbeLoader.load(hdrUrl, (texture) => {
      texture.mapping = THREE.EquirectangularReflectionMapping;

      // Set the map as an environment
      scene.environment = texture;
      //scene.environmentIntensity = 1;
      scene.environment.needsUpdate = true;
      //scene.background = texture;
    });
  } else if (hdrLoader === HDR_MAP_LOADER.pmremGenerator) {
    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    const rgbeLoader = new RGBELoader();
    rgbeLoader.load(hdrUrl, (hdrTexture) => {
        const envMap = pmremGenerator.fromEquirectangular(hdrTexture).texture;
        scene.environment = envMap;
        //scene.background = envMap;
        scene.environmentIntensity = 1;
        scene.environment.needsUpdate = true;

        // Optional: Clean up resources
        hdrTexture.dispose();
        pmremGenerator.dispose();
      },
      undefined, // onProgress
      (error) => {
        console.error('An error occurred loading the HDR texture:', error);
      });
  } else if (hdrLoader === HDR_MAP_LOADER.pmremGeneratorEXR) {
    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();
    new EXRLoader().load(hdrUrl,function (texture) {
      const exrCubeRenderTarget = pmremGenerator.fromEquirectangular(texture);
      const newEnvMap = exrCubeRenderTarget ? exrCubeRenderTarget.texture : null;
      scene.environment = newEnvMap;
      //scene.background = newEnvMap;
      scene.environmentIntensity = 1;
      scene.environment.needsUpdate = true;

      // Optional: Clean up resources
      //texture.dispose();
      //pmremGenerator.dispose();
    });
  }
}
